import { useEffect, useState } from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Bento from "@/components/Bento";
import Animals from "@/components/Animals";
import Adopt from "@/components/Adopt";
import Volunteer from "@/components/Volunteer";
import Wishlist from "@/components/Wishlist";
import Merch from "@/components/Merch";
import ShopComingSoon from "@/components/ShopComingSoon";
import Transparency from "@/components/Transparency";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";
import { Reveal } from "@/components/Reveal";
import { api, scrollToId } from "@/lib/helpers";
import { SHOW_SHOP } from "@/lib/data";

function Story() {
  return (
    <section id="story" className="relative bg-sand py-20 sm:py-24 lg:py-28 overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-12 lg:grid-cols-12">
          <Reveal className="lg:col-span-6">
            <div className="grid grid-cols-2 gap-4 sm:gap-6">
              <div className="overflow-hidden rounded-[2rem] rounded-tl-[5rem] shadow-xl">
                <img src="/sections/story_fog.webp"
                  alt="Fog rolling through the sanctuary pines" className="aspect-[3/4] w-full object-cover" />
              </div>
              <div className="overflow-hidden rounded-[2rem] rounded-br-[5rem] shadow-xl mt-10">
                <img src="/sections/story_biscuit.webp"
                  alt="Biscuit the golden retriever" className="aspect-[3/4] w-full object-cover" />
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.15} className="lg:col-span-6">
            <p className="eyebrow">Our story</p>
            <h2 className="mt-3 font-serif text-2xl sm:text-3xl lg:text-4xl text-charcoal tracking-tight leading-snug">
              It started with one cold puppy, a broken-down truck and a mountain road.
            </h2>
            <p className="mt-5 text-bark leading-relaxed">
              Our founders pulled over for one shivering puppy on a mountain road — and never really drove away.
              Today Wag n Tails is a mountain retreat in Maryland where dogs and cats
              get whatever they need: surgery, time, or simply a soft place to land.
            </p>
            <p className="mt-4 text-bark leading-relaxed">
              Some of our residents heal and head home. Others — the seniors and the special-needs kids —
              live out their days here as sanctuary ambassadors. All of them are family.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <button data-testid="story-adopt-cta" onClick={() => scrollToId("adopt")}
                className="rounded-full bg-pine px-7 py-3.5 font-bold text-sand hover:bg-pine-mid transition-all hover:scale-[1.03]">
                Start an adoption
              </button>
              <button data-testid="story-donate-cta" onClick={() => scrollToId("donate")}
                className="rounded-full border-2 border-pine px-7 py-3.5 font-bold text-pine hover:bg-pine hover:text-sand transition-all">
                Support the sanctuary
              </button>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}

export default function Home() {
  const [campaign, setCampaign] = useState(null);
  const [adoptTarget, setAdoptTarget] = useState(null);

  useEffect(() => {
    api.get("/campaign").then(({ data }) => setCampaign(data)).catch(() => {});
  }, []);

  const goDonate = () => scrollToId("donate");

  return (
    <main className="bg-sand">
      <Nav onDonate={goDonate} />
      <Hero onDonate={goDonate} />
      <Marquee />
      <Bento campaign={campaign} />
      <Animals onAdopt={setAdoptTarget} />
      <Adopt adoptTarget={adoptTarget} setAdoptTarget={setAdoptTarget} />
      <Volunteer />
      <Wishlist />
      {SHOW_SHOP ? <Merch /> : <ShopComingSoon />}
      <Transparency />
      <Footer />
      <ChatWidget />
    </main>
  );
}
